export const GET_CURRENCIES = "GET_CURRENCIES";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const CANCEL_PAYMENT = "CANCEL_PAYMENT";
export const RESET_PAYMENT = "RESET_PAYMENT";
export const CONFIRM_PAYMENT = "CONFIRM_PAYMENT";
export const TRACK_PAYMENT = "TRACK_PAYMENT";
export const RESET_CURRENCIES = "RESET_CURRENCIES";
